import { createContext } from 'react';

export const AccessManagement2NModalContext = createContext(null);

